const CANDIDATE_PERSONAL_FALLBACK_KEY = "candidate_personal_fallback";

const readCandidatePersonalFallbacks = () => {
  try {
    const savedFallbacks = localStorage.getItem(
      CANDIDATE_PERSONAL_FALLBACK_KEY,
    );
    return savedFallbacks ? JSON.parse(savedFallbacks) : {};
  } catch (error) {
    return {};
  }
};

export const getCandidatePersonalFallback = (candidateId) => {
  if (!candidateId) return {};
  const savedFallbacks = readCandidatePersonalFallbacks();
  return savedFallbacks[String(candidateId)] || {};
};

export const saveCandidatePersonalFallback = (candidateId, data = {}) => {
  if (!candidateId) return;
  try {
    const savedFallbacks = readCandidatePersonalFallbacks();
    savedFallbacks[String(candidateId)] = {
      ...savedFallbacks[String(candidateId)],
      ...data,
    };
    localStorage.setItem(
      CANDIDATE_PERSONAL_FALLBACK_KEY,
      JSON.stringify(savedFallbacks),
    );
  } catch (error) {
    // Ignore localStorage write failures; the API response remains the source of truth.
  }
};
